import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_the_footer = _resolveComponent("the-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_empty, {
            description: '(｡•ˇ‸ˇ•｡) 404未找到页面 ⚆_⚆？',
            style: {"margin-top":"200px"},
            image: require('@/assets/404.png'),
            "image-style": { height: '200px', }
          }, null, 8, ["image"])
        ]),
        _: 1
      }),
      _createVNode(_component_the_footer)
    ]),
    _: 1
  }))
}